import * as React from "react";
const YouTube = (props) => (
  <svg
    width={69}
    height={48}
    viewBox="0 0 69 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_393_9463)">
      <path
        d="M66.7606 7.48667C66.3691 6.03962 65.6053 4.72038 64.5453 3.66034C63.4853 2.6003 62.1661 1.83643 60.719 1.4448C55.4214 0 34.1004 0 34.1004 0C34.1004 0 12.7782 0.0437332 7.48063 1.48853C6.03357 1.88019 4.71435 2.6441 3.65435 3.70419C2.59435 4.76428 1.83056 6.08357 1.43903 7.53067C-0.163367 16.9435 -0.784968 31.2864 1.48303 40.3227C1.8746 41.7697 2.63841 43.089 3.69841 44.149C4.7584 45.209 6.0776 45.9729 7.52463 46.3645C12.8222 47.8093 34.1438 47.8093 34.1438 47.8093C34.1438 47.8093 55.4652 47.8093 60.7625 46.3645C62.2096 45.9729 63.5288 45.2091 64.5889 44.1491C65.6489 43.089 66.4128 41.7698 66.8044 40.3227C68.4945 30.8965 69.0153 16.5624 66.7606 7.48667Z"
        fill="#FF0000"
      />
      <path
        d="M27.3139 34.1494L45.0014 23.9046L27.3139 13.6598V34.1494Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_393_9463">
        <rect width={68.27} height={48} fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default YouTube;
